// extracted by mini-css-extract-plugin
module.exports = {"List":"styles_List__UghuO","OneFile":"styles_OneFile__x7ypV","TwoFiles":"styles_TwoFiles__gYADu","ThreeFiles":"styles_ThreeFiles__9qm0n","FourFiles":"styles_FourFiles__0SQy_"};